// 初始化全局图片路径
if (typeof window !== 'undefined') {
    window.PDA_IMAGE_PATH = window.PDA_IMAGE_PATH
        ? window.PDA_IMAGE_PATH
        : 'https://img.alicdn.com/imgextra/i3/';
}
export const PDA_IMAGE_PATH = typeof window !== 'undefined' ? window.PDA_IMAGE_PATH : 'https://img.alicdn.com/imgextra/i3/';
